import React, { Component } from 'react';
import { Modal, Row, Col, Input, Button, TreeSelect, message, Popconfirm, Empty, Tag } from 'antd';
import Reorder, { reorder } from 'react-reorder';
import '../index.css';

import { _getAllCategories, _postUpdateLeafPage } from '../../../services/index';

import CategoryTreeSelect from './tree-select'

const confirm = Modal.confirm;

class EditGroupModal extends Component {


  constructor(props) {
    super(props);

    this.state = {
      allSubCategories: [],
      categories: [],
      currentGroupIndex: 0,
      // currentGroup: this.props.currentGroup,
      // currentGroup: {
      //   subCategories: []
      // },
      treeData: [],
    }
  }

  componentDidMount() {
    _getAllCategories()
      .then(res => {

        // console.log(res.data.categories);

        let categories = res.data.categories;
        // let treeData = [];
        // let newGroup = this.props.currentGroup;

        
        // newGroup.subCategories.sort(( a, b ) => {
        //   if (a.position < b.position)
        //   return -1;
        //   if (a.position > b.position)
        //   return 1;
        //   return 0;
        // })
        
        // console.log(newGroup)
      

        // categories.map(( category, catIndex ) => {

        //   let newChildren = [];

        //   category.children.map(( subCat, subIndex ) => {

        //     let binaryCatIndex = this.formatNumberLength(catIndex, 3);
        //     let binarySubIndex = this.formatNumberLength(subIndex, 3);

        //     newChildren.push({
        //       title: subCat.title,
        //       value: `${binaryCatIndex}${binarySubIndex}${subCat.title}`,
        //       key: subCat.titleUrl
        //     });

        //     return subCat;
        //   })

        //   treeData.push({
        //     title: category.title,
        //     value: 'parent',
        //     key: category._id,
        //     children: newChildren
        //   });

        //   return category;
        // })

        this.setState({ 
          categories: categories,
          // treeData: treeData,
          // // currentGroup: newGroup,
          currentGroupIndex: this.props.currentGroupIndex
        });

      })
      .catch(err => console.error(err));
  }

  render() {

    return (
      <div>
        <Modal
          title="Edit Group"
          visible={this.props.visible}
          footer={<Button onClick={this.props.onCancel} type="primary">Back to Groups</Button>}
          onCancel={this.props.onCancel}
          // onOk={this.onEditModalOk}
          // okText="Save"
          width={1200}
        >
          <Row type="flex" align="middle" style={{ marginBottom: 15 }}>
            <Col span={5}>
              <img
                src={this.props.currentGroup.imageURL}
                alt="group"
                height={180}
                width={180}
              />
            </Col>
            <Col span={19}>
              <Row type="flex">
                <Input 
                  style={{ fontSize: 30, fontWeight: '500', padding: '25px 10px', marginBottom: 15, width: '90%', border: 'none' }}
                  placeholder="Enter Group Name"
                  value={this.props.currentGroup.name}
                  onChange={(e) => this.props.onGroupNameChange(e, this.props.currentGroupIndex)}
                />
              </Row>
              
              <Row type="flex">
                <Input 
                  style={{ fontSize: 30, fontWeight: '500', padding: '25px 10px', marginBottom: 15, width: '90%', border: 'none' }}
                  placeholder="Enter Mobile Group Name"
                  value={this.props.currentGroup.mobileName}
                  onChange={(e) => this.props.onMobileGroupNameChange(e, this.props.currentGroupIndex)}
                />
              </Row>

              <Row type="flex">
                <Input
                  placeholder="Enter Image URL"
                  value={this.props.currentGroup.imageURL}
                  onChange={(e) => this.props.onImageURLChange(e, this.props.currentGroupIndex)}
                  style={{ marginBottom: 15, width: '90%', border: 'none' }}
                />
                <Input
                  placeholder="Enter Mobile Image URL"
                  value={this.props.currentGroup.mobileImageURL}
                  onChange={(e) => this.props.onMobileImageURLChange(e, this.props.currentGroupIndex)}
                  style={{ marginBottom: 15, width: '90%', border: 'none' }}
                />
              </Row>
            </Col>
          </Row>
          <Row type="flex" align="middle" className="table-header">
            <Col span={3}>
              <span>Image</span>
            </Col>
            <Col span={8}>
              <span>Sub Catergory</span>
            </Col>
            <Col span={3}>
              <span>Status</span>
            </Col>
            <Col span={6}>
              <span>Image Link</span>
            </Col>
            <Col span={2}>
              <span>Actions</span>
            </Col>
            <Col span={2}>
              <Button onClick={() => this.props.onAddFakeSubCategory()} icon="plus">Add</Button>
            </Col>
          </Row>
          {Array.isArray(this.props.currentGroup.subCategories) ?
            <Reorder
              reorderId="sub-categories"
              reorderGroup="sub-cat-page"
              component="div"
              draggedClassName="dragged-list-item"
              lock="horizontal"
              holdTime={200}
              disabled={false}
              onReorder={this.onReorder}
            >
              {
                this.props.currentGroup.subCategories.map(( subCat, index ) => (
                  <Row type="flex" key={index} align="middle" className="group-page-item">
                    <Col span={3}>
                      <img 
                        src={subCat.imageURL}
                        alt="Sub category"
                        height={80}
                        width={80}
                      />
                    </Col>
                    <Col span={8}>
                      {/* <TreeSelect 
                        showSearch
                        value={subCat.name}
                        style={{ width: 300 }}
                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                        placeholder="Select Sub Category"
                        allowClear
                        treeData={this.state.treeData}
                        onChange={(value) => this.onTreeSelectChange(value, index)}
                        treeDefaultExpandAll
                      /> */}
                      <CategoryTreeSelect
                        categories={this.state.categories}
                        value={subCat.name}
                        onTreeSelectChange={(value) => this.onTreeSelectChange(value, index)}
                      />
                    </Col>
                    <Col span={3}>
                    {subCat.active ? <Tag color="green">Active</Tag> : <Tag color="red">Deactive</Tag>}
                    </Col>
                    <Col span={5}>
                      <Input placeholder="Image URL" value={subCat.imageURL} />
                    </Col>
                    <Col offset={1} span={4}>
                      <Input.Group compact>
                        <Popconfirm
                          title="Delete Sub Category?"
                          placement="bottomRight"
                          cancelText="Delete"
                          okText="No"
                          onCancel={() => this.onDelete(index)}
                        >
                        `<Button type="danger">Delete</Button>
                        </Popconfirm>
                        <Popconfirm
                          title={subCat.active ? "Deactivate Group?" : "Activate Group?"}
                          okText="No"
                          cancelText="Yes"
                          onCancel={() => this.onActivationClick(index, subCat.active)}
                        >
                          <Button type="primary">{subCat.active ? <span>Deactivate</span> : <span>Activate</span>}</Button>
                        </Popconfirm>
                      </Input.Group>
                    </Col>
                  </Row>
                ))
              }
            </Reorder> : <Empty/>
          }
        </Modal>
      </div>
    );
  }
  
  onEditModalOk = () => {
    // this.props.updateGroup(this.props.currentGroup, this.props.currentGroupIndex);
    this.props.onCancel();
  }

  onTreeSelectChange = (value, index) => {

    let newSubCats = this.props.currentGroup.subCategories;


    if (newSubCats[index].active) {
      message.error("Please deactivate before making changes!")
    }
    else if (value.includes('parent')) {
      message.error("Please only select Sub Categories!", 3);
    }
    else if (typeof value === "string") {

      let catIndex = parseInt(value.substring(0, 3), 10);
      let subIndex = parseInt(value.substring(3, 6), 10);

      let alreadyPresent = false;

      console.log(catIndex, subIndex);
      let chosenSubCat = this.state.categories[catIndex].children[subIndex];

      console.log(chosenSubCat)

      newSubCats.map(( subCat ) => {
        if (subCat.name === chosenSubCat.title) {
          alreadyPresent = true;
        }

        return subCat;
      })

      if (alreadyPresent) {
        message.error("You have already chosen that Sub Category!", 3);
      } else {
        newSubCats[index].name = chosenSubCat.title;
        newSubCats[index].kebabName = chosenSubCat.titleUrl;
        newSubCats[index].imageURL = chosenSubCat.image;
  
        this.props.updateSubCats(newSubCats);

      }      
    } else {
      let newSubCats = this.props.currentGroup.subCategories;

      newSubCats[index].name = "";
      newSubCats[index].kebabName = "";
      newSubCats[index].imageURL = "";
    }

    this.props.onGroupChange();
  }


  onReorder = ( event, previousIndex, nextIndex, fromId, toId ) => {
    let newSubCats = reorder( this.props.currentGroup.subCategories, previousIndex, nextIndex );

    newSubCats.map((subCat, index) => {
      subCat.position = index;

      return subCat;
    })

    this.props.updateSubCats(newSubCats);

    let newLeaf = this.props.currentLeafPage;
    newLeaf.groups[this.props.currentGroupIndex].subCategories = newSubCats;

    _postUpdateLeafPage( newLeaf )
      .then(res => {
        this.props.updateData();
        message.success('Sub Categories reordered!', 2);
      })
      .catch(err => {
        message.error('Groups reordering failed.', 2);
        console.log(err);
      })

    // this.setState( prevState => ({
    //   currentGroup: {
    //     ...prevState.currentGroup,
    //     subCategories: newSubCat
    //   }
    // }));

    // this.props.onGroupChange();
  }

  onDelete = (index) => {
    let newSubCats = this.props.currentGroup.subCategories;

    if (newSubCats[index].active) {
      message.error('Please deactivate a Sub Category before deleting!', 3);
    } else {
      newSubCats.splice(index, 1);
  
      let newLeaf = this.props.currentLeafPage;
      newLeaf.groups[this.props.currentGroupIndex].subCategories = newSubCats;
  
      _postUpdateLeafPage( newLeaf )
        .then(res => {
          this.props.updateData();
          message.success('Sub Category successfully deleted!', 2);
        })
        .catch(err => {
          message.error('Deletion failed.', 2);
          console.log(err);
        })
  
      this.props.onGroupChange();
    }
  }

  formatNumberLength = ( num, length ) => {
    let r = "" + num;
    while (r.length < length) {
        r = "0" + r;
    }
    return r;
  }

  onActivationClick = ( subCatIndex, activation ) => {
    let newLeaf = this.props.currentLeafPage;
    let groupIndex = this.props.currentGroupIndex;

    let onlyGroup = this.isLastActiveGroup();

    // console.log(!activation)
    // console.log(this.isLastActiveGroup())
    // console.log(this.isLastActiveSubCat())

    if (!activation) { // Deactive-> Active
      if (newLeaf.groups[groupIndex].subCategories[subCatIndex].name === "") {
        message.error('Please choose a Sub Category before activating!', 3);
      } else {
        newLeaf.groups[groupIndex].subCategories[subCatIndex].active = true;
        this.updateLeafPage( newLeaf );
      }
    } else if (typeof onlyGroup === 'object' && this.isLastActiveSubCat() && newLeaf.active) {
      confirm({
        title: 'Deactivating this will cause parent Leaf Page and Group to deactivate!',
        content: <div>
          <p>This is to prevent users from entering a empty Leaf Page or Group. Once you've done your changes, reactivate these again</p>
          <br/>
          <p>Leaf Page: "{newLeaf.leafName}"</p>
          <br/>
          <p>Group:     "{onlyGroup.name}"</p>
        </div>,
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          newLeaf.groups[groupIndex].subCategories[subCatIndex].active = false;
          newLeaf.groups[groupIndex].active = false;
          newLeaf.active = false;

          this.updateLeafPage( newLeaf );
        },
      })
    } else if (typeof onlyGroup === 'object' && this.isLastActiveSubCat()) {
      confirm({
        title: 'Deactivating this will cause parent Group to deactivate!',
        content: <div>
          <p>This is to prevent users from entering a empty Leaf Page or Group. Once you've done your changes, reactivate these again</p>
          <br/>
          <p>Group: "{newLeaf.groups[groupIndex].name}"</p>
        </div>,
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          newLeaf.groups[groupIndex].subCategories[subCatIndex].active = false;
          newLeaf.groups[groupIndex].active = false;

          this.updateLeafPage( newLeaf );
        },
      })
    } else {
      newLeaf.groups[groupIndex].subCategories[subCatIndex].active = false;
      this.updateLeafPage( newLeaf );
    }

    // _postUpdateLeafPage( newLeaf )
    // .then(res => {
    //   this.props.updateData();
    //   message.warning('Sub Category status switched!')
    // })
    // .catch(err => console.error(err));
    
  }

  updateLeafPage = ( newLeaf ) => {
    _postUpdateLeafPage( newLeaf )
    .then(res => {
      this.props.updateData();
      message.warning('Sub Category status switched!')
    })
    .catch(err => console.error(err));
  }

  isLastActiveSubCat = () => {
    // console.log(this.props.curre)
    let subCats = this.props.currentLeafPage.groups[this.props.currentGroupIndex].subCategories;
    let result = 0;

    subCats.map( subCat => { 
      if (subCat.active) {
        result++;
      } 

      return subCat;
    });

    if (result === 1)
      return true;
  }

  isLastActiveGroup = () => {
    let groups = this.props.currentLeafPage.groups;
    let result = 0;
    let onlyGroup = {};

    groups.map( group => { 
      if (group.active) {
        result++; 
        onlyGroup = group;
      }

      return group;
    });

    if (result === 1) 
      return onlyGroup
    else
      return false;
  }

}

export default EditGroupModal;


// WEBPACK FOOTER //
// ./src/components/leaf-page/modals/edit-group.js